import { MapPin, Truck, Zap, Plane, Clock } from "lucide-react";

// Maps a First Freight service code to a clear, colour-coded chip so staff can see at a
// glance which service a quote/waybill uses. LOC = local delivery, ECO = economy road.
const SERVICE_META = {
  LOC: { label: "Local (LOC)", cls: "bg-teal-100 text-teal-800 border-teal-200", Icon: MapPin },
  ECO: { label: "Economy (ECO)", cls: "bg-blue-100 text-blue-800 border-blue-200", Icon: Truck },
  ONX: { label: "Overnight (ONX)", cls: "bg-purple-100 text-purple-800 border-purple-200", Icon: Clock },
  NAF: { label: "Air Freight (NAF)", cls: "bg-sky-100 text-sky-800 border-sky-200", Icon: Plane },
  LSD: { label: "Local Sameday (LSD)", cls: "bg-amber-100 text-amber-800 border-amber-200", Icon: Zap },
};

const ServiceBadge = ({ service, className = "", size = "sm", testId }) => {
  const code = (service || "").toString().trim().toUpperCase();
  if (!code) return null;
  const meta = SERVICE_META[code] || {
    label: code,
    cls: "bg-slate-100 text-slate-700 border-slate-200",
    Icon: Truck,
  };
  const { label, cls, Icon } = meta;
  const isXs = size === "xs";
  const pad = isXs ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs";
  const iconSize = isXs ? "w-2.5 h-2.5" : "w-3 h-3";
  return (
    <span
      data-testid={testId || `service-badge-${code.toLowerCase()}`}
      className={`inline-flex items-center gap-1 rounded-full border font-medium whitespace-nowrap ${cls} ${pad} ${className}`}
    >
      <Icon className={iconSize} />
      {label}
    </span>
  );
};

export default ServiceBadge;
